export const makePdf = async (els, fileName) => {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  for (const [i, el] of els.filter(Boolean).entries()) {
    const canvas = await html2canvas(el, {
      scale: 2, backgroundColor: "#ffffff", ignoreElements: (n) => n.classList?.contains("no-print") || n.classList?.contains("no-pdf"),
      onclone: (doc) => doc.querySelectorAll(".pdf-only").forEach((s) => { s.style.display = "block"; }),
    });
    const h = (canvas.height * 190) / canvas.width;
    const w = h > 277 ? (190 * 277) / h : 190;
    if (i) pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 10 + (190 - w) / 2, 10, w, Math.min(h, 277));
  }
  return new File([pdf.output("blob")], fileName, { type: "application/pdf" });
};

export const toB64 = (file) => new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result.split(",")[1]); r.readAsDataURL(file); });
